import { BASE_API_URL } from './index';

export const companyTagsEndpoint = `${BASE_API_URL}/tagging/tags/`;
export const createItemTagLinksEndpoint = (itemId) => `${BASE_API_URL}/items/${itemId}/tag_links/`;
